import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProject } from '../contexts/ProjectContext';
import { logActivity } from '../services/activityLog.service';
import { ActivityAction, ActivityEntityType } from '../types/activityLog.types';

interface LogParams {
  action: ActivityAction;
  entityType: ActivityEntityType;
  entityId?: string;
  entityName?: string;
  projectId?: string;
  projectName?: string;
  details?: Record<string, any>;
}

/**
 * Hook that returns a logActivity function pre-filled with current user info.
 * Fire-and-forget — never blocks the caller.
 */
export function useActivityLogger() {
  const { userProfile } = useAuth();
  const { selectedProject } = useProject();

  const log = useCallback((params: LogParams) => {
    if (!userProfile) return;

    logActivity({
      userId: userProfile.uid,
      userName: userProfile.name || userProfile.email,
      userRole: userProfile.role,
      organizationId: userProfile.organizationId || undefined,
      projectId: params.projectId || selectedProject?.id,
      projectName: params.projectName || selectedProject?.name,
      ...params,
    });
  }, [userProfile, selectedProject]);

  return { logActivity: log };
}
